import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateCustomerBirthday = {
  name: "updateCustomerBirthday" as const,
  input: z.object({ customerId: zExt.objectId(), birthday: z.date() }),
  output: z.object({ success: z.boolean() }),
};
